import { Directive, ElementRef, Renderer2, OnInit, HostListener } from '@angular/core';

@Directive({
  selector: '[appAutoAdjustTextArea]'
})
export class AutoAdjustTextAreaDirective implements OnInit {

  constructor(private render: Renderer2, private el: ElementRef) { }

  ngOnInit() {
    this.resizeHeight();
  }

  @HostListener('keyup') onkeyup() {
    this.resizeHeight();
  }

  resizeHeight() {
    this.render.setStyle(this.el.nativeElement, 'height', 'auto');
    this.render.setStyle(this.el.nativeElement, 'height', this.el.nativeElement.scrollHeight + 'px');
  }
}
